/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_Token_SaveInputs */

const cs_import_auth_token_save = /** @type {(inputs: Import_Auth_Token_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít token`)
};

const en_import_auth_token_save = /** @type {(inputs: Import_Auth_Token_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use token`)
};

/**
* | output |
* | --- |
* | "Use token" |
*
* @param {Import_Auth_Token_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_token_save = /** @type {((inputs?: Import_Auth_Token_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_Token_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_token_save(inputs)
	return cs_import_auth_token_save(inputs)
});